/**
 * SEO Component - Dynamic meta tags for each page
 * Uses react-helmet-async to update document head
 */
import { Helmet } from 'react-helmet-async'

const DEFAULT_TITLE = 'Marketing Tools – Đất Xanh Miền Trung'
const DEFAULT_DESCRIPTION = 'Nền tảng Marketing Tools của Đất Xanh Miền Trung cung cấp tin tức bất động sản, dữ liệu dự án, tài liệu bán hàng và bản đồ ma trận giá theo khu vực.'
const DEFAULT_IMAGE = '/dat_xanh_mien_trung.jpg'
const SITE_NAME = 'Marketing Tools DXMT'
const BASE_URL = 'https://marketingtools.datxanhmientrung.vn'

function SEO({
  title,
  description = DEFAULT_DESCRIPTION,
  image = DEFAULT_IMAGE,
  url,
  type = 'website',
  noIndex = false,
}) {
  const fullTitle = title ? `${title} | ${SITE_NAME}` : DEFAULT_TITLE
  const fullUrl = url ? `${BASE_URL}${url}` : BASE_URL
  const fullImage = image.startsWith('http') ? image : `${BASE_URL}${image}`

  return (
    <Helmet>
      {/* Basic */}
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {noIndex && <meta name="robots" content="noindex, nofollow" />}

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={fullImage} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:locale" content="vi_VN" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={fullImage} />
    </Helmet>
  )
}

export default SEO
